var indentStyle = {"indentZero":"joH6k","indentOne":"AbLMk","indentTwo":"yl0Vn","indentThree":"-CgJ9","indentFour":"JS87B","indentFive":"wN5Bi","indentSix":"YKKbX"};

export { indentStyle as i };
//# sourceMappingURL=indentation-a893f5f8.js.map
